import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function QROrder() {
	const [searchParams] = useSearchParams();
	const accountNumber = searchParams.get("account");
	const { verifyPin, user } = useAuth();
	const navigate = useNavigate();
	
	const [pin, setPin] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	
	useEffect(() => {
		if (user) navigate("/order");
	}, [user, navigate]);
		
		if (!accountNumber) {
			return (
				<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
				text-center border border-farm-tan/30
				dark:border-gray-700">
				<div className="text-5xl mb-4">🔗</div>
				<h2 className="text-xl font-bold text-red-600 dark:text-red-400">
				Invalid QR Code
				</h2>
				<p className="text-gray-600 dark:text-gray-400 mt-2">
				This link is missing your account identifier. Please scan your
				personal QR code again.
				</p>
				</div>
			);
		}
		
		const handleSubmit = async (e) => {
			e.preventDefault();
			setError("");
			setLoading(true);
			try {
				await verifyPin(accountNumber, pin);
				navigate("/order");
			} catch (err) {
				setError(
					err.response?.data?.error || "Incorrect PIN. Please try again."
				);
				setPin("");
			} finally {
				setLoading(false);
			}
		};
		
		return (
			<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
			border border-farm-tan/30 dark:border-gray-700
			max-w-sm mx-auto transition-colors duration-200">
			<div className="text-center mb-6">
			<div className="text-5xl mb-3">🥚</div>
			<h2 className="text-2xl font-bold text-farm-green dark:text-green-400">
			Quick Order
			</h2>
			<p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
			Account:{" "}
			<span className="font-mono font-semibold">{accountNumber}</span>
			</p>
			<p className="text-gray-500 dark:text-gray-400 text-sm">
			Enter your PIN to place an egg order.
			</p>
			</div>
			
			{error && (
				<div className="bg-red-50 dark:bg-red-900/30 border border-red-300
				dark:border-red-600 text-red-700 dark:text-red-300
				rounded-lg p-3 mb-4 text-sm">
				{error}
				</div>
			)}
			
			<form onSubmit={handleSubmit} className="space-y-4">
			<div>
			<label className="block text-sm font-medium text-gray-700
			dark:text-gray-300 mb-1">
			PIN
			</label>
			<input
			type="password"
			required
			value={pin}
			onChange={(e) => setPin(e.target.value)}
			placeholder="Enter your PIN"
			maxLength={8}
			inputMode="numeric"
			className="w-full border border-gray-300 dark:border-gray-600
			rounded-lg px-3 py-3 text-center text-2xl
			tracking-widest bg-white dark:bg-gray-700
			text-gray-800 dark:text-gray-100
			focus:outline-none focus:ring-2 focus:ring-farm-green"
			/>
			</div>
			
			<button
			type="submit"
			disabled={loading}
			className="w-full bg-farm-green text-white py-3 rounded-xl
			font-semibold hover:bg-green-700 transition-colors
			disabled:opacity-60"
			>
			{loading ? "Verifying…" : "Continue to Order"}
			</button>
			</form>
			
			<p className="mt-4 text-center text-xs text-gray-400 dark:text-gray-500">
			Need to manage your account?{" "}
			<a
			href="/login"
			className="text-farm-green dark:text-green-400 hover:underline"
			>
			Sign in with email
			</a>
			</p>
			</div>
		);
}
